class W4D_AsideNav {
	constructor() {
		if (!document.body.classList.contains('archive')) {
			return;
		}

		this.initSelectors();
		this.bindEvents();
	}

	initSelectors() {
		this.expandableLinks = document.querySelectorAll('.aside-nav a[data-aside-nav-toggle]');
	}

	bindEvents() {
		const boundToggle = this.toggleSubmenu.bind(this);
		for (const link of this.expandableLinks) {
			link.addEventListener('click', boundToggle);
		}
	}

	toggleSubmenu(e) {
		const toggle = e.currentTarget;
		if (!e.target.closest('[data-aside-nav-chevron]')) return;

		e.preventDefault();

		const submenu = toggle.nextElementSibling;

		if (!submenu || submenu.tagName !== 'UL') return;

		const isCurrentlyOpen = toggle.getAttribute('aria-expanded') === 'true';
		const transitionDuration = 300;

		if (isCurrentlyOpen) {
			// CLOSING: Close nested submenus
			const nestedToggles = submenu.querySelectorAll('a[data-aside-nav-toggle][aria-expanded="true"]');
			for (const nestedToggle of nestedToggles) {
				nestedToggle.setAttribute('aria-expanded', 'false');
				this.markSubmenuClosing(nestedToggle.nextElementSibling, transitionDuration);
			}

			toggle.setAttribute('aria-expanded', 'false');
			this.markSubmenuClosing(submenu, transitionDuration);
		} else {
			submenu.removeAttribute('data-closing');
			toggle.setAttribute('aria-expanded', 'true');
		}
	}

	markSubmenuClosing(submenu, transitionDuration) {
		if (!submenu || submenu.tagName !== 'UL') return;

		submenu.setAttribute('data-closing', 'true');
		setTimeout(() => {
			submenu.removeAttribute('data-closing');
		}, transitionDuration);
	}
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => new W4D_AsideNav());
} else {
	new W4D_AsideNav();
}
